@if (componentType; as componentType) {
  <ng-container [ngComponentOutlet]="componentType" [ngComponentOutletInputs]="{ config: config() }"></ng-container>
}
